import { useEffect } from 'react';
/**
 * Applies props to an element, via a React ref.
 *
 * @param ref The element to apply the props to.
 * @param props The props to apply to the element.
 */ export const useProps = (ref, props)=>{
    useEffect(()=>{
        const listeners = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(props)){
            // for each event handler prop, wire up an event listener on the reference element
            if (key.startsWith('on')) {
                const eventName = key.slice(2).toLowerCase();
                const handler = value;
                const el = ref.current;
                if (el) {
                    el.addEventListener(eventName, handler);
                    listeners.push(()=>{
                        el.removeEventListener(eventName, handler);
                    });
                }
            } else if (typeof value === 'boolean') {
                // if the value is a boolean, set or remove the attribute as appropriate
                // see: https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute
                if (value) {
                    var _ref_current;
                    (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.setAttribute(key, '');
                } else {
                    var _ref_current1;
                    (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.removeAttribute(key);
                }
            } else if (!value && value !== 0) {
                var // if the value is empty, null or undefined, remove the attribute
                _ref_current2;
                (_ref_current2 = ref.current) === null || _ref_current2 === void 0 ? void 0 : _ref_current2.removeAttribute(key);
            } else {
                var // otherwise, set the attribute to the value
                _ref_current3;
                (_ref_current3 = ref.current) === null || _ref_current3 === void 0 ? void 0 : _ref_current3.setAttribute(key, value);
            }
        }
        return ()=>{
            listeners.forEach((listener)=>listener());
        };
    }, [
        ref,
        props
    ]);
};

//# sourceMappingURL=useProps.js.map